import { useState } from 'react';
import { useController } from 'react-hook-form';
import classNames from 'classnames';
import Error from '../Error';
import { ChevronDown, Loader } from 'react-feather';
import Label from '../Label';
import Instruction from '../Instruction';
import SubInstruction from '../SubInstruction';
var classes = {
    inputGroup: {
        base: 'flex items-center gap-4 px-4 w-full relative rounded-md border border-gray-300 text-base transition-colors focus:border-2 focus:border-brand-dark',
        error: 'border-alert-danger focus:border-alert-danger',
    },
    input: 'w-4/5 sm:w-full flex-1 appearance-none focus:outline-none placeholder-gray-500 rounded-md py-[14px]',
    icon: 'pointer-event-none text-gray-900',
};
var Select = function (_a) {
    var label = _a.label, name = _a.name, control = _a.control, _b = _a.defaultValue, defaultValue = _b === void 0 ? '' : _b, _c = _a.required, required = _c === void 0 ? false : _c, instructions = _a.instructions, subInstructions = _a.subInstructions, choices = _a.choices, placeholder = _a.placeholder;
    var _d = useController({ name: name, control: control, defaultValue: defaultValue }), field = _d.field, fieldState = _d.fieldState;
    var _e = useState(false), showSubInstructions = _e[0], setShowSubInstructions = _e[1];
    return (<div className="flex w-full flex-col">
      {label && (<Label label={label} htmlFor={name} required={required} tooltip={!!subInstructions} onTooltipClick={function () { return setShowSubInstructions(true); }}/>)}
      {instructions && <Instruction instruction={instructions}/>}
      {subInstructions && (<SubInstruction instruction={subInstructions} open={showSubInstructions} close={function () { return setShowSubInstructions(false); }}/>)}
      <div className={classNames(classes.inputGroup.base, fieldState.error && classes.inputGroup.error)}>
        {choices && choices.length ? (<select className={classes.input} {...field}>
            {placeholder && (<option value="" disabled>
                {placeholder}
              </option>)}
            {choices === null || choices === void 0 ? void 0 : choices.map(function (choice) { return (<option key={choice.value} value={choice.value}>
                {choice.label}
              </option>); })}
          </select>) : (<div className={classNames(classes.input, 'flex items-center justify-center')}>
            <Loader className="animate-spin-loader text-gray-400"/>
          </div>)}
        <ChevronDown className={classes.icon} size={18}/>
      </div>
      {fieldState.error && <Error message={fieldState.error.message}/>}
    </div>);
};
export default Select;
